module.exports = __webpack_public_path__ + "static/media/iris_cropped_2.8a4a3e43.png";